import { Handshake, Home } from "@mui/icons-material";
import React, { useState } from "react";
import RegisterBookContent from "../../../../../components/reg_book/RegisterBookContent";
import { useGetRegBookAgreementQuery } from "../../../../../redux/api/submittedCopyrightAgreementApiSlice";
import AgreementTable from "../../../../../components/reg_book/AgreementTable";
import Loader from "../../../../../components/custom/Loader";

const UnauthorizedBookAgreement = () => {
  const bookType = 2;
  const [trackReg, setTrackReg] = useState("");
  const { data, isLoading } = useGetRegBookAgreementQuery({
    bookType,
    trackReg,
  });
  const breadcrumbsData = [
    { icon: Home, title: "হোম", url: "/" },
    {
      icon: Handshake,
      title: "চুক্তিপত্র - অননুমোদিত রেজিস্টার বুক",
      active: true,
    },
  ];

  const applicationPath = {
    copyright: "/admin/unauthorized-register-book-copyright",
    agreement: "/admin/unauthorized-register-book-agreement",
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <RegisterBookContent
      data={data}
      trackReg={trackReg}
      setTrackReg={setTrackReg}
      content={<AgreementTable data={data} />}
      breadcrumbsData={breadcrumbsData}
      applicationPath={applicationPath}
    />
  );
};

export default UnauthorizedBookAgreement;
